import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ExplorarPage = lazy(() => import('../pages/explorar/page'));
const AvisoLegalPage = lazy(() => import('../pages/aviso-legal/page'));
const PoliticaPrivacidadPage = lazy(() => import('../pages/politica-de-privacidad/page'));
const PoliticaCookiesPage = lazy(() => import('../pages/politica-de-cookies/page'));
const AvisoAfiliacionPage = lazy(() => import('../pages/aviso-de-afiliacion/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/explorar',
    element: <ExplorarPage />,
  },
  {
    path: '/aviso-legal',
    element: <AvisoLegalPage />,
  },
  {
    path: '/politica-de-privacidad',
    element: <PoliticaPrivacidadPage />,
  },
  {
    path: '/politica-de-cookies',
    element: <PoliticaCookiesPage />,
  },
  {
    path: '/aviso-de-afiliacion',
    element: <AvisoAfiliacionPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
